import { Controller } from 'stimulus'
import debounce from '../utils/debounce'

export default class extends Controller {
  static targets = ['item']

  initialize() {
    this._matchHeights = debounce(this.matchHeights.bind(this), 200)
  }

  matchHeights() {
    const maxHeight = this.itemTargets
      .map(item => item.offsetHeight)
      .reduce((currentMax, height) => Math.max(currentMax, height))
    this.itemTargets.forEach(item => (item.style.minHeight = `${maxHeight}px`))
  }

  connect() {
    setTimeout(() => {
      this.matchHeights()
    }, 150)
    window.addEventListener('resize', this._matchHeights)
    window.addEventListener('orientationchange', this._matchHeights)
  }

  disconnect() {
    window.removeEventListener('resize', this._matchHeights)
    window.removeEventListener('orientationchange', this._matchHeights)
  }
}
